import React, { useEffect, useState } from "react";
import Tooltip from "@mui/material/Tooltip";
import { styled } from "@mui/system";

const StyledTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} arrow />
))({
    "& .MuiTooltip-tooltip": {
        backgroundColor: "#111827",
        color: "#ffffff",
        borderRadius: "0.95rem",
        boxShadow: "0 14px 30px rgba(15, 23, 42, 0.24)",
        padding: "0.82rem 1.12rem",
        fontSize: "0.98rem",
        fontWeight: 600,
        lineHeight: 1.15,
        letterSpacing: 0,
        maxWidth: "18rem",
        overflow: "visible"
    },
    "& .MuiTooltip-arrow": {
        color: "#111827"
    },
    '&[data-popper-placement*="top"] .MuiTooltip-arrow': {
        bottom: "1px"
    },
    '&[data-popper-placement*="bottom"] .MuiTooltip-arrow': {
        top: "-1px"
    },
    '&[data-popper-placement*="left"] .MuiTooltip-arrow': {
        right: "-1px"
    },
    '&[data-popper-placement*="right"] .MuiTooltip-arrow': {
        left: "-1px"
    }
});

function ActionTooltip({ title, placement = "top", children }) {
    const tooltipEnabled = Boolean(title);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        if (!tooltipEnabled && open) {
            setOpen(false);
        }
    }, [tooltipEnabled, open]);

    useEffect(() => {
        if (!open) {
            return undefined;
        }

        const closeTooltip = () => setOpen(false);

        window.addEventListener("scroll", closeTooltip, true);
        window.addEventListener("wheel", closeTooltip, { passive: true });
        window.addEventListener("touchmove", closeTooltip, { passive: true });

        return () => {
            window.removeEventListener("scroll", closeTooltip, true);
            window.removeEventListener("wheel", closeTooltip);
            window.removeEventListener("touchmove", closeTooltip);
        };
    }, [open]);

    return (
        <StyledTooltip
            title={title || ""}
            placement={placement}
            open={tooltipEnabled && open}
            disableInteractive
            disableHoverListener
            disableFocusListener
            disableTouchListener
            enterDelay={0}
            leaveDelay={0}
            enterNextDelay={0}
            enterTouchDelay={0}
            leaveTouchDelay={0}
            TransitionProps={{ timeout: 0 }}
        >
            <span
                style={{ display: "inline-flex" }}
                onMouseEnter={() => tooltipEnabled && setOpen(true)}
                onMouseLeave={() => setOpen(false)}
                onFocus={() => tooltipEnabled && setOpen(true)}
                onBlur={() => setOpen(false)}
            >
                {children}
            </span>
        </StyledTooltip>
    );
}

export default ActionTooltip;
